export const ADMIN_ROLES = ['ADMIN', 'SUPER_ADMIN'];
export const STAFF_ROLES = ['ORGANIZER', 'ORGANIZER_STAFF', 'ADMIN', 'SUPER_ADMIN'];
export const GATE_ROLES = ['ORGANIZER', 'GATE_STAFF', 'ADMIN', 'SUPER_ADMIN'];

export const isAdminRole = (role) => ADMIN_ROLES.includes(role);

export const isSuperAdminRole = (role) => role === 'SUPER_ADMIN';

export const isStaffRole = (role) => STAFF_ROLES.includes(role);

export const isOrganizerRole = (role) => role === 'ORGANIZER';

export const isOrganizerStaffRole = (role) => role === 'ORGANIZER_STAFF';

export const isOrganizerFamilyRole = (role) =>
  role === 'ORGANIZER' || role === 'ORGANIZER_STAFF';

export const isGateStaffRole = (role) => role === 'GATE_STAFF';
